import { useMutate } from "../../../core/hooks/useMutate";

export function useUpdateImageControl(ceremonyId: number, blockId: number) {
    return useMutate(`ceremonies/${ceremonyId}/blocks/${blockId}`, "PATCH");
}
